import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { IApiCentre, IApiCentresServeiMunicipis } from "../services/api.model";
import { CentresPreinscripcioService } from "../services/centres-preinscripcio.service";
import { Ofertes } from "../services/ofertes.service";
import { SharedProperties } from "../services/share.service";

class Component {
  centre: IApiCentre;
  centres: IApiCentresServeiMunicipis[];
  selectedTab: number;
  haveCenters: boolean;
  resolve: { centre: IApiCentre; centres: IApiCentresServeiMunicipis[]; selectedTab: number; haveCenters: boolean };
  modalInstance: ng.ui.bootstrap.IModalInstanceService;

  constructor(
    private CentresPreinscripcio: CentresPreinscripcioService,
    private Ofertes: Ofertes,
    private SharedProperties: SharedProperties,
    private $uibModal: ng.ui.bootstrap.IModalService,
  ) { }

  $onInit() {
    this.centre = this.resolve.centre;
    this.centres = this.resolve.centres;
    this.selectedTab = this.resolve.selectedTab;
    this.haveCenters = this.resolve.haveCenters;
  }

  showOfertaCentre(centre): void {
    this.$uibModal.open(
      {
        animation: true,
        component: AppComponentsEnum.CENTRES_SFP,
        size: 'lg',
        windowClass: 'center-modal',
        resolve: {
          'ofertaCentreSFP': () => this.Ofertes.getOfertaCentre(centre, { sostingutFonsPublic: 'S' }),
          'centre': () => centre,
          'selectorCurs': () => this.SharedProperties.getSelectedCurs(),
        }
      }
    );
  }

  showCentreOnMap(): void {
    const objFilterBbox = this.setFilterAndBBox();
    const centresAdscrits = this.centres || [];

    if (this.selectedTab === 0) {
      Promise.all(
        centresAdscrits.map((centre) => this.CentresPreinscripcio.getGeoserverCentresServeis(centre))
      ).then((data) => {
        this.modalInstance.close({
          filter: objFilterBbox.filter,
          bboxObj: objFilterBbox.bboxObj,
          dataGeoserver: data,
        });
      });
    } else {
      this.modalInstance.close({ filter: objFilterBbox.filter, bboxObj: objFilterBbox.bboxObj });
    }
  }

  centerCentre(elem: IApiCentresServeiMunicipis): void {
    const offset = 100;
    const coordX = Number((elem?.coordX || '').replace(',', '.'));
    const coordY = Number((elem?.coordY || '').replace(',', '.'));
    const PROP = this.selectedTab === 2 ? 'CODI_CENTRE' : 'COD_CENTRES_DOCENTS';
    const newFilter = `(1=1) AND (${PROP}='${elem.codi}')`;
    const bboxObj = {
      bboxCentre: [coordX - offset, coordY - offset, coordX + offset, coordY + offset],
      bboxGeo: [],
    };

    if (this.selectedTab === 0) {
      this.CentresPreinscripcio.getGeoserverCentresServeis(elem).then((data) => {
        this.modalInstance.close({
          filter: newFilter,
          bboxObj: bboxObj,
          dataGeoserver: [data],
        });
      });
    } else {
      this.modalInstance.close({ filter: newFilter, bboxObj: bboxObj });
    }
  }

  ok(): void {
    this.modalInstance.close();
  }

  private setFilterAndBBox(): { filter: string; bboxObj: { bboxGeo: number[] } } {
    const totalAdscrits = [];
    const coordsX: number[] = [];
    const coordsY: number[] = [];
    let filter = '(1=1)';
    const offset = 100;

    if (this.centres.length) {
      totalAdscrits.push(...this.centres);
    }

    if (totalAdscrits.length) {
      filter += ' AND (';
      totalAdscrits.forEach((centre, index) => {
        if (this.checkCoords(centre)) {
          if (index > 0) filter += ' OR ';
          const PROP = this.selectedTab === 2 ? 'CODI_CENTRE' : 'COD_CENTRES_DOCENTS';
          filter += `${PROP}='${centre.codi}'`;
          coordsX.push(Number((centre?.coordX || '').replace(',', '.')));
          coordsY.push(Number((centre?.coordY || '').replace(',', '.')));
        }
      });
      filter += ')';

      const minX = Math.min(...coordsX) - offset;
      const minY = Math.min(...coordsY) - offset;
      const maxX = Math.max(...coordsX) + offset;
      const maxY = Math.max(...coordsY) + offset;

      return { filter, bboxObj: { bboxGeo: [minX, minY, maxX, maxY] } };
    }

    return { filter, bboxObj: { bboxGeo: [] } };
  }

  checkCoords(elem: any): boolean {
    return (
      elem?.coordX !== null &&
      elem?.coordY !== null &&
      elem?.coordX?.trim() !== '' &&
      elem?.coordY?.trim() !== ''
    );
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    modalInstance: "<",
    resolve: "<",
  },
  templateUrl: './components/modal-centres-suports.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.CENTRES_SUPORTS, component);